import { ApiRequest } from './api-request';
import { ApiRequestOrdering } from './api-request-ordering';

/**
 * Api ordered request
 */
export class ApiOrderedRequest extends ApiRequest {
	ordering?: ApiRequestOrdering;
}
